import React, { useState } from 'react'
import styles from '../styles.module.css'
import { summGraduatesDetailsActions } from '../../../../redux/reducers/SummGraduatesHEO/summGraduatesHEOReducer';
import { useDispatch, useSelector } from 'react-redux'
import DetailsButtons from './DetailsButtons';

const Table = ({ data, reportParams }) => {
  
  const [name, setName] = useState('');
  const dispatch = useDispatch();
  
  const details = useSelector(state => state.reports.summGraduatesHEO.details);

  if (!data) return null;
  
  const {['Всего по училищу']: summ, ['Всего по поступает в вузы']: summAll, ...restData} = data

  const renderRow = (schoolName, index) => {
    const values = restData[schoolName]
    return (
      <tr>
        <th>{index + 1}</th>
        <th style={{ minWidth: '300px'}}>{schoolName}</th>
        {summ.map((el, i) => {
          const value = values.find(val => val.idorganization === el.idorganization)
          const students = value ? value.students : ''
          return <td check={i} onClick={() => onCellClick(value, i)} key={el.idorganization}>{students}</td>
        })}
      </tr>
    )
  }

  
  
  const onCellClick = (el = {}, i) => {
    // if (i === 0) return;
    setName(el.orgname)
    const payload = {school: el.idorganization || 0, vuz: el.university_id, students: el.IDs};
    const { summGraduatesDetailsRequestStart } = summGraduatesDetailsActions;
      dispatch(summGraduatesDetailsRequestStart(payload))
    }

  return (
    <div className={styles.tableBlock}>
      <h3 className={"text-center mb-2"}>СВЕДЕНИЯ</h3>
      <h3 className={"text-center mb-2"}>о количестве выпускников довузовских образовательных организаций Министерства обороны Российской Федерации,</h3>
      <h3 className={"text-center mb-2"}>{`планирующих поступать в ${reportParams.year} году в высшие военно-учебные заведения`} </h3>
      <table id='summGraduatesTable' className={`${styles.mainTable} ${styles.rotateTable}`}>
        <thead>
          <tr>
            <th rowSpan={2}>№ п/п</th>
            <th style={{ minWidth: '300px'}} rowSpan={2}>Наименование военной образовательной организации</th>
            <th rowSpan={2}>Количество воспитанников, поступающих в вузы</th>
            <th colSpan={summ.length-1}>Из них:</th>
          </tr>
          <tr>
            {summ.filter(i => i.idorganization).map((el, i) => 
            <th key={el.orgname}>{el.orgname}</th>)}
          </tr>
          <tr>
            <th colSpan={2} >ВСЕГО ВЫПУСКНИКОВ</th>
            {summ.map((i) => <td key={i.orgname}>{i.students}</td>)}
          </tr>
        </thead>
        <tbody>
          {Object.keys(restData).map(renderRow)}
          <tr>
            <th colSpan={2}>ВСЕГО ПОСТУПАЮТ В ВУЗЫ МО РФ</th>
            {summAll.map((i) => <td key={i.orgname}>{i.students}</td>)}
          </tr>
        </tbody>
      </table>

      {!!details && details.length && name ? 
      <>
      <h3 className={"text-center mb-2 mt-5"}>{name}</h3>
      <h3 className={"text-center mb-2"}>Список воспитанников, поступающих в вузы</h3>
      <DetailsButtons 
        visible={!!details} 
        reportParams={reportParams}
        name={name}
        />
      <table id='details_summGraduatesTable' className={styles.mainTable}>
        <thead>
          <tr>
            <th>№ п/п</th>
            <th>ФИО</th>
            <th>Училище</th>
            <th>Специальность</th>
          </tr>
        </thead>
        <tbody>
          {
            details.map((_el, index) => 
              <tr key={_el.mid}>
                  <td>{index + 1}</td>
                  <td>{`${_el.lastname} ${_el.firstname} ${_el.patronymic}`}</td>
                  <td>{name}</td>
                  <td>{_el.speciality}</td>
                </tr>
              )
            }
        </tbody>
      </table>

      </> : <></>
      }
    </div>
  )
}

export default Table